export default function ObrasParalisadas() {
    const currentYear = new Date().getFullYear();
    const currentDate = new Date().toLocaleDateString('pt-BR');
    const startYear = 2022;
    const years = [];

    for (let year = startYear; year <= currentYear; year++) {
        if (year === currentYear) {
            years.push(`${year} - Até o momento, ${currentDate}, não há registro de obras paralisadas.`);
        } else {
            years.push(`${year} - Não há registro de obras paralisadas.`);
        }
    }

    return (
        <div className="container mt-4">
            <p><small>Você está em <a href="/prestacao-de-contas">Prestação de Contas</a> / Obras Paralisadas</small></p>
            <h1 className="mb-4">Obras Paralisadas</h1>
            {years.map((msg, idx) => (
                <p key={idx}>{msg}</p>
            ))}
        </div>
    );
}
